import React from "react";

/** Keeps one broken page from unmounting the whole site. */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("Page failed to render:", error, info?.componentStack);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <section className="max-w-2xl mx-auto px-4 sm:px-6 py-20 text-center" data-testid="page-error-fallback">
        <h1 className="font-display text-2xl sm:text-3xl font-bold text-ei-navy">This page didn't load</h1>
        <p className="mt-3 text-sm text-ei-graphite/80">
          Something went wrong on our side. Nothing you were doing has been charged or lost. Reload to try again, or
          call sales on <a href="tel:0414662445" className="font-semibold text-ei-navy underline">0414 662 445</a>.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <button
            onClick={() => window.location.reload()}
            className="font-display text-sm font-bold bg-ei-navy text-ei-white px-5 py-3 rounded-sm hover:bg-ei-ink transition-colors min-h-[44px]"
            data-testid="page-error-reload"
          >
            Reload this page
          </button>
          <a
            href="/"
            className="font-display text-sm font-bold text-ei-navy border border-ei-navy/25 px-5 py-3 rounded-sm hover:border-ei-navy min-h-[44px] inline-flex items-center"
            data-testid="page-error-home"
          >
            Back to home
          </a>
        </div>
      </section>
    );
  }
}

export default ErrorBoundary;
